import React from 'react';
import './UnauthorizedPopup.css';

interface UnauthorizedPopupProps {
    onClose: () => void;
}

const UnauthorizedPopup: React.FC<UnauthorizedPopupProps> = ({ onClose }) => {
    return (
        <div className="unauthorized-popup-overlay">
            <div className="unauthorized-popup-content">
                <div className="unauthorized-icon">⚠️</div>
                <h3>Yetkisiz Erişim</h3>
                <p>Bu sayfayı ziyaret etme yetkiniz bulunmamaktadır. Lütfen yöneticiniz ile görüşün.</p>
                <button className="unauthorized-close-btn" onClick={onClose}>
                    Tamam
                </button>
            </div>
        </div>
    );
};

export default UnauthorizedPopup;
